if (!window.customElements.get("nutrition-table")) {
  class NutritionTable extends HTMLElement {
    constructor() {
      super();
      this.tableData = null;
      this.lastRawData = null;
    }
  
    connectedCallback() {
      this.init();
    }

    static get observedAttributes() {
      return ["data-table"];
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === "data-table" && oldValue !== newValue && this.isConnected) {
        this.init();
      }
    }
  
    init() {
      const rawData = this.getAttribute('data-table');
      if (!rawData) {
        console.error('data-table attribute is missing or empty');
        this.clearTable();
        return;
      }

      if (rawData === this.lastRawData && this.querySelector('table')) {
        return;
      }
  
      try {
        this.tableData = JSON.parse(rawData);
        this.lastRawData = rawData;
        this.renderTables();
      } catch (error) {
        console.error(error);
        this.clearTable();
      }
    }

    clearTable() {
      this.innerHTML = '';
    }
  
    createTableRow(values) {
      const tr = document.createElement('tr');
      values.forEach(value => {
        const td = document.createElement('td');

        if (Array.isArray(value)) {
          value.forEach((item, index) => {
            const div = document.createElement('div');
            div.textContent = item;

            if (index > 0) {
              div.classList.add('nutrition-subrow');
            }

            td.appendChild(div);
          });
        } else {
          td.textContent = value;
        }
        tr.appendChild(td);
      });
      return tr;
    }
  
    createTableHead(table) {
      const thead = document.createElement('thead');
      const headerRow = document.createElement('tr');
  
      Object.keys(this.tableData).forEach(col => {
        const th = document.createElement('th');
        th.setAttribute('scope', 'col');
        th.textContent = this.tableData[col].title;
        headerRow.appendChild(th);
      });
  
      thead.appendChild(headerRow);
      table.appendChild(thead);
    }
  
    createTableBody(table) {
      const tbody = document.createElement('tbody');
      const dataValues = Object.keys(this.tableData).map(col => this.tableData[col].values);

      if (!dataValues.length) {
        table.appendChild(tbody);
        return;
      }

      const maxRows = Math.max(...dataValues.map(column => column.length));
  
      for (let i = 0; i < maxRows; i++) {
        const rowData = dataValues.map(column => column[i] ?? '');
        const row = this.createTableRow(rowData);
        tbody.appendChild(row);
      }
  
      table.appendChild(tbody);
    }
  
    renderTables() {
      this.clearTable();
      const table = document.createElement('table');
      this.createTableHead(table);
      this.createTableBody(table);
      this.appendChild(table);
    }
  }
  
  customElements.define('nutrition-table', NutritionTable);
}